/**
 * Note: due to the setup and webpack config of this project
 * we do not need to export the files, because every js file is being imported into the 'assets/customer.js' file
 * meaning that these are globally accessible.
 * @TODO - update webpack config to have single (or multiple) js entry point instead of concatinating each js file
 */
export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}